"use client";
export { default } from "@/views/error/error-boundary";